import type { DomainConfigItem } from './domainConfig'

/* Nodo plano de la tabla `domain`, con la relacion padre/hijo que vive en BD.
   Hermano de buildDomainLists: aquella aplana a Record<listKey, string[]> y
   pierde ids; esta conserva id y parent_id para derivar la jerarquia. */
export interface DomainNode {
  id: string
  name: string
  type: string
  parent_id: string | null
}

interface RawDomainRow {
  id?: string
  name?: string
  parent_id?: string | null
}

/* Aplana la respuesta de GET_DOMAINS (un alias por tipo) a una lista unica
   de nodos. Descarta filas sin id o sin nombre util. */
export function buildDomainNodes(
  domainsData: Record<string, RawDomainRow[]> | undefined,
  config: DomainConfigItem[]
): DomainNode[] {
  if (!domainsData) return []

  const nodes: DomainNode[] = []

  for (const item of config) {
    const rows = domainsData[item.alias] ?? []
    for (const row of rows) {
      const id = String(row?.id ?? '').trim()
      const name = String(row?.name ?? '').trim()
      if (!id || !name) continue

      const parentId = String(row?.parent_id ?? '').trim()
      nodes.push({
        id,
        name,
        type: item.type,
        parent_id: parentId || null,
      })
    }
  }

  return nodes
}
